export default [{
	path: 'manage',
	meta: {
		title: '质检管理'
	},
	component: () => import('@/pages/quality/manage')
}, {
	path: 'assets',
	meta: {
		title: '上传图片'
	},
	props: route => route.query,
	component: () => import('@/pages/quality/assets')
}, {
	path: 'assets/mark',
	meta: {
		title: '标记瑕疵图'
	},
	props: route => route.query,
	component: () => import('@/pages/quality/assets_mark')
}]